<div *ngIf="web">
    <div class="desktop" *ngIf="isMenuOpen('inicio')">
        <app-menu-principal [usuario]="userJson"></app-menu-principal>
    </div>
    <div class="desktop" *ngIf="isMenuOpen('serviciotecnico')">
        <app-menu-principal [usuario]="userJson"></app-menu-principal>
    </div>
    <div class="desktop" *ngIf="isMenuOpen('tallermovil')">
        <app-menu-principal [usuario]="userJson"></app-menu-principal>
    </div>
    <div class="desktop" *ngIf="isMenuOpen('takata')">
        <app-menu-principal [usuario]="userJson"></app-menu-principal>
    </div>
    <div class="desktop" *ngIf="isMenuOpen('usuario')">
        <app-menu-principal [usuario]="userJson"></app-menu-principal>
    </div>
    <div class="desktop" *ngIf="isMenuOpen('tiendavirtual')">
        <app-menu-ecommerce [usuario]="userJson" [carrito]="cantidadCarrito" [carritociudad]="ciudadPedido" [carritosucursal]="sucursalCarrito"></app-menu-ecommerce>
    </div>
    <div class="desktop" *ngIf="isMenuOpen('b2b')">
        <app-menu-b2b [usuario]="userJson" [carrito]="cantidadCarrito" [carritociudad]="ciudadPedido" [carritosucursal]="sucursalCarrito"></app-menu-b2b>
    </div>
    <div class="desktop" id="head-login" *ngIf="isMenuOpen('login')">
        <a class="navbar-brand" routerLink="">
            <img src="https://res.cloudinary.com/toyosa-sa/image/upload/v1713559522/production/plataforma-toyota/web/assets/icons/comunications/logo_toyosa_negro.svg" width="145" height="35" alt="Logo toyosa" class="mx-4 mt-2 logo"/>
        </a> 
    </div>
    <app-mobile class="mobile" id="menu-mobile" [usuario]="userJson" [carrito]="cantidadCarrito" [carritociudad]="ciudadPedido" [carritosucursal]="sucursalCarrito"></app-mobile>
</div>

<ng-template #brand let-modal id="brand">
    <div class="modal-header">
      <h4 class="modal-title">En qué ciudad te encuentras?</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row">
            <a class="col-12 city-type-link" (click)="enableDisableCiudades(0, '')" [style.background-color]="toggle[0] ? 'transparent' : '#171a20'" [style.color]="toggle[0] ? '#171a20' : '#ffffff'">La Paz</a>
            <a class="col-12 city-type-link" (click)="enableDisableCiudades(1, '')" [style.background-color]="toggle[1] ? 'transparent' : '#171a20'" [style.color]="toggle[1] ? '#171a20' : '#ffffff'">Cochabamba</a>
            <a class="col-12 city-type-link" (click)="enableDisableCiudades(2, '')" [style.background-color]="toggle[2] ? 'transparent' : '#171a20'" [style.color]="toggle[2] ? '#171a20' : '#ffffff'">Santa Cruz</a>
            <a class="col-12 city-type-link" (click)="enableDisableCiudades(3, '')" [style.background-color]="toggle[3] ? 'transparent' : '#171a20'" [style.color]="toggle[3] ? '#171a20' : '#ffffff'">Oruro</a>
            <a class="col-12 city-type-link" (click)="enableDisableCiudades(4, '')" [style.background-color]="toggle[4] ? 'transparent' : '#171a20'" [style.color]="toggle[4] ? '#171a20' : '#ffffff'">Potosí</a>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Cerrar</button>
    </div>
  </ng-template>